<div
  style="
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh;
    flex-direction: column;
    position: fixed;
    width: 100%;
  ">
  <h1>{{ 'HEADER.ACCESS_DENIED' | translate }}</h1>
</div>
